import React from 'react';
import {View} from 'react-native';

import {buttonsStyles} from '../../../Button/boutonStyle';
import PrimaryButton from '../../../Button/PrimaryButton';
import {Container} from '../../../Container';
import styles from './style';

interface Props {
  active?: string;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  callBack: Function;
}
export default function TypeVersementTab({active, callBack}: Props) {
  return (
    <Container>
      <View style={styles.formContainer}>
        <View style={buttonsStyles.btnTabWrapper}>
          <PrimaryButton
            onPress={() => callBack('Cotisation')}
            styleBtnTxt={[
              buttonsStyles.btnTabTxt,
              active === 'Cotisation' && buttonsStyles.btnTabTxtActive,
            ]}
            styleBtnOuter={[
              buttonsStyles.btnTabOuter,
              active === 'Cotisation' && buttonsStyles.btnTabOuterActive,
            ]}
            title="Cotisation"
          />
          <PrimaryButton
            onPress={() => callBack('Pension')}
            styleBtnTxt={[
              buttonsStyles.btnTabTxt,
              active === 'Pension' && buttonsStyles.btnTabTxtActive,
            ]}
            styleBtnOuter={[
              buttonsStyles.btnTabOuter,
              active === 'Pension' && buttonsStyles.btnTabOuterActive,
            ]}
            title="Rente"
          />
          <PrimaryButton
            onPress={() => callBack('Capital')}
            styleBtnTxt={[
              buttonsStyles.btnTabTxt,
              active === 'Capital' && buttonsStyles.btnTabTxtActive,
            ]}
            styleBtnOuter={[
              buttonsStyles.btnTabOuter,
              active === 'Capital' && buttonsStyles.btnTabOuterActive,
            ]}
            title="Capital"
          />
        </View>
      </View>
    </Container>
  );
}
